/**
 * RefreshButton — clears the server-side Power BI cache and refetches.
 *
 * Extracted from the identical markup that AmazonDashboard and
 * EcommerceDashboard each carried, so the Dashboard and PortcoDetail pages
 * don't add a third and fourth copy.
 */

interface RefreshButtonProps {
  onClick: () => void;
  refreshing: boolean;
  /** Overrides the default hover title. */
  title?: string;
  className?: string;
}

export function RefreshButton({
  onClick,
  refreshing,
  title = "Clear cache and refresh data",
  className = "",
}: RefreshButtonProps) {
  return (
    <button
      onClick={onClick}
      disabled={refreshing}
      className={`flex items-center gap-1.5 px-3 py-1.5 text-sm font-medium text-gray-600 bg-white border border-gray-200 rounded-lg hover:bg-gray-50 hover:border-gray-300 transition-colors disabled:opacity-50 ${className}`}
      title={title}
    >
      <svg
        className={`w-4 h-4 ${refreshing ? "animate-spin" : ""}`}
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
        />
      </svg>
      {refreshing ? "Refreshing…" : "Refresh"}
    </button>
  );
}
